import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CompanyName, LabelValue, Office, ServiceSimple, User } from './types';

export interface CommonState {
  loading: boolean;
  candidate_loading: boolean;
  steps_loading: boolean;
  openings_loading: boolean;
  /* `getListHrManagers` pre-shapes the API response into `{ value, label }`
      before dispatching, so this slice stores select-option pairs, not raw users. */
  hr_managers: LabelValue[];
  recruiterLeads: LabelValue[];
  list_hrl: User[];
  services: ServiceSimple[];
  locations: Office[];
  languages: string[];
  levels: string[];
  positions: string[];
  companies: CompanyName[];
}

export const initialState: CommonState = {
  loading: false,
  candidate_loading: false,
  steps_loading: false,
  openings_loading: false,
  hr_managers: [],
  recruiterLeads: [],
  list_hrl: [],
  services: [],
  locations: [],
  languages: [],
  levels: [],
  positions: [],
  companies: [],
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoading(state, { payload }: PayloadAction<boolean>) {
      state.loading = payload;
    },
    setCandidateLoading(state, { payload }: PayloadAction<boolean>) {
      state.candidate_loading = payload;
    },
    setStepsLoading(state, { payload }: PayloadAction<boolean>) {
      state.steps_loading = payload;
    },
    setOpeningsLoading(state, { payload }: PayloadAction<boolean>) {
      state.openings_loading = payload;
    },
    setListServices(state, { payload }: PayloadAction<ServiceSimple[]>) {
      state.services = payload;
    },
    setListLocations(state, { payload }: PayloadAction<Office[]>) {
      state.locations = payload;
    },
    setListHrManagers(state, { payload }: PayloadAction<LabelValue[]>) {
      state.hr_managers = payload;
    },
    setRecruiterLeads(state, { payload }: PayloadAction<LabelValue[]>) {
      state.recruiterLeads = payload;
    },
    setListHRL(state, { payload }: PayloadAction<User[]>) {
      state.list_hrl = payload;
    },
    setForeignLanguages(state, { payload }: PayloadAction<string[]>) {
      state.languages = payload;
    },
    setLevels(state, { payload }: PayloadAction<string[]>) {
      state.levels = payload;
    },
    setPositions(state, { payload }: PayloadAction<string[]>) {
      state.positions = payload;
    },
    setAllCompanies(state, { payload }: PayloadAction<CompanyName[]>) {
      state.companies = payload;
    },
    resetCommonReducer(_state) {
      _state = initialState;
    },
  },
});

export const {
  setLoading,
  setCandidateLoading,
  setStepsLoading,
  setOpeningsLoading,
  setListServices,
  setListLocations,
  setListHrManagers,
  setRecruiterLeads,
  setListHRL,
  setForeignLanguages,
  setLevels,
  setPositions,
  setAllCompanies,
  resetCommonReducer,
} = commonSlice.actions;
export default commonSlice.reducer;
